export default __webpack_public_path__ + "static/shoutout-image-a-b7da030efb79ca33e0f1791d0bd8c2f8.png";